import { createFileRoute } from '@tanstack/react-router';

import { crownQueryClient } from '@/common/api/crownQueryClient';
import { queryApplicationOptions } from '@/features/provider-panel/application-filling/api/queryApplication';
import { fullName } from '@/lib/fullName';
import { Application } from '@/features/provider-panel/application-filling/Application.tsx';

export const Route = createFileRoute(
  '/provider/$providerId/applications/$applicationId',
)({
  loader: async ({ params }) =>
    crownQueryClient.ensureQueryData(
      queryApplicationOptions(params.providerId, params.applicationId),
    ),
  head: ({ loaderData: application }) => ({
    meta: [{ title: application ? fullName(application) : 'Application' }],
  }),
  component: Application,
});
